export default "__VITE_ASSET__Cug0jt4e__"